import { Launch } from "@mui/icons-material";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

import ValueWithFallback from "../../../../../StaticBar/components/ui/ValueWithFallback";
import { ACTION_TYPE } from "../../../../types/actionTypes";

import DateTimeModel from "./fields/DateTimeModel";
import STRINGS from "./utils/strings";

const SelectedFollowUpView = ({ selectedFollowUp, navigateToDetail }) => {
  const FormatPhoneNumber = (phoneNumberString) => {
    if (phoneNumberString) {
      const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
      const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        const intlCode = match[1] ? "+1 " : "";
        return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
      }
    }
    return " ";
  };

  return (
    <div id="Follow-Up-View" data-testid="Follow-Up-View">
      <div className="border-1 border-solid border-slate-500 p-2 text-left">
        <div>
          {STRINGS.SCHEDULED_FOR}: <div className="text-[1rem]">{selectedFollowUp.label}</div>
        </div>
        <div className="border-1 border-solid border-slate-500 py-2 text-left">
          <div className="text-[.75rem]">Client Name: </div>
          <div className="text-[1rem]">{selectedFollowUp.client.name}</div>
        </div>
        <div className="border-1 border-solid border-slate-500 py-2 text-left">
          <div className="text-[.75rem]">Due Date: </div>
          <div className="text-[1rem]">
            {selectedFollowUp.fields.dueDate && DateTimeModel(selectedFollowUp.fields.dueDate)}
          </div>
          <span className="italic">
            {selectedFollowUp.timeTillDueDate && " (" + selectedFollowUp.timeTillDueDate + ")"}
          </span>
        </div>
        <div className="border-1 border-solid border-slate-500 py-2 text-left">
          <div className="text-[.75rem]">Follow-up Details: </div>
          <div className="text-[1rem]">{selectedFollowUp.fields.detail}</div>
        </div>

        {selectedFollowUp.actionType === ACTION_TYPE.PROVIDER_FOLLOW_UP && (
          <div className="border-1 border-solid border-slate-500 py-2 text-left">
            <div className="text-[.75rem]">Provider Name:</div>
            <div className="text-[1rem]">{selectedFollowUp?.fields.provider.name}</div>
            <div className="pt-2 text-[.75rem]">Phone Number: </div>
            <div className="text-[1rem]">
              {ValueWithFallback(FormatPhoneNumber(selectedFollowUp?.fields.provider.phone))}
            </div>
          </div>
        )}
        {selectedFollowUp.actionType === ACTION_TYPE.LAW_FIRM_FOLLOW_UP && (
          <div className="border-1 border-solid border-slate-500 py-2 text-left">
            <div className="text-[.75rem]">Law Firm Name:</div>
            <div className="text-[1rem]">{selectedFollowUp.lawFirm.name}</div>
            <div className="pt-2 text-[.75rem]">Phone Number: </div>
            <div className="text-[1rem]">
              {ValueWithFallback(FormatPhoneNumber(selectedFollowUp.lawFirm.phone))}
            </div>
          </div>
        )}
      </div>
      <hr />
      <div className="border-1 border-solid border-slate-500 py-2 text-left">
        <div className="text-[.75rem]">
          {" "}
          Status:{" "}
          <span className="uppercase">
            {selectedFollowUp.status && selectedFollowUp.status === "pending"
              ? "In-Complete"
              : "Complete"}
          </span>
        </div>

        {selectedFollowUp.status && selectedFollowUp.status === "done" && (
          <>
            <div className="text-[0.85rem]">
              <div className="text-[.75rem]">Completed By: </div>
              {selectedFollowUp.completedBy && selectedFollowUp.completedBy.name}
            </div>
            <div className="text-[0.85rem]">
              Completed At:{" "}
              {selectedFollowUp.completedAt && DateTimeModel(selectedFollowUp.completedAt)}
            </div>
          </>
        )}

        <Button
          title="Open Case Details"
          className="text-sky-600 hover:bg-sky-600 hover:text-white"
          onClick={() => navigateToDetail(selectedFollowUp.caseId)}
        >
          Navigate to Case <Launch />
        </Button>
      </div>
    </div>
  );
};

export default SelectedFollowUpView;

SelectedFollowUpView.propTypes = {
  selectedFollowUp: PropTypes.object,
  navigateToDetail: PropTypes.func,
};
